<ul class="navbar-nav flex-column p-0">

      <vertical-menu-item-with-children
        [itemClassName]="'nav-item px-0'"
      />
      <vertical-menu-item
        [itemClassName]="'nav-item ps-0'"
      />
</ul>
